import * as React from "react";
import { CardOverlay } from "../components/Overlay/CardOverlay";
import { UndoOverlay } from "../UndoOverlay";
import { HideThisOutput } from "@utils";


interface HideThisItemContainerProps {
    hideThisOutput?: HideThisOutput
    children: React.ReactChild | React.ReactChild[]
    update?: (out: HideThisOutput) => void
    hideThis: () => void
    hasTimer: boolean
    onMouseLeave: (event: React.MouseEvent<HTMLDivElement>) => void
}


export const HideThisItemContainer: React.StatelessComponent<HideThisItemContainerProps> = (props: HideThisItemContainerProps) => {
    return props.hideThisOutput && props.hideThisOutput.tellUsWhyAction ?
        <CardOverlay content={
            <UndoOverlay
                hasTimer={props.hasTimer}
                {...props.hideThisOutput}
                onUndo={
                    props.update
                }
                onHideThis={
                    props.hideThis
                }
            />}
            onMouseLeave={props.onMouseLeave}
        >
            {props.children}
        </CardOverlay> :
        <>{props.children}</>
}